// Service pages that Resources articles link to. Plain JS (no JSX) so the
// Node-side loader can read it for the Article structured data.
import { CUSTOM_QUOTE } from '../../lib/pricing.js';

export const SERVICES = {
  gdpr: { name: 'GDPR Representative', href: '/gdpr-representative/' },
  'ai-act': { name: CUSTOM_QUOTE.services[1], href: '/eu-ai-act-representative/' },
  dsa: { name: CUSTOM_QUOTE.services[0], href: '/dsa-legal-representative/' },
  'data-act': { name: CUSTOM_QUOTE.services[2], href: '/eu-data-act-representative/' },
};

export const PRICING_PAGE = { name: 'Pricing', href: '/pricing/' };

// The first <PricingSummary ... /> in an MDX body, as { plan, service }, or null.
export const findPricingSummary = (body) => {
  const m = String(body).match(/<PricingSummary\b([^>]*?)\/?>/);
  if (!m) return null;
  const attr = (name, fallback) => (m[1].match(new RegExp(`${name}="([^"]+)"`)) || [])[1] || fallback;
  return { plan: attr('plan', 'essential'), service: attr('service', 'gdpr') };
};
